module.exports = __webpack_public_path__ + "static/home-mail-5942807873d3e72227abe09b729cb5c2.png";